export const queryKeys = {
  treatments: 'treatments',
  appointments: 'appointments',
  staff: 'staff',
  user: 'user',
  clients: 'clients',
  employees: 'employees',
  shippings: 'shippings',
  shippingFiles: 'shippingFiles',
  parcelFiles: 'parcelFiles',
  passportFiles: 'passportFiles',
  reports: 'reports',
  agency: 'agency',
  passportServiceType: 'passportServiceType',
  parcelContentTypes: 'parcelContentTypes',
  contentCategories: 'contentCategories',
  agencyProducts: 'agencyProducts',
  ordersByShipment: 'ordersByShipment',
  couriers: 'couriers',
  dispatchers: 'dispatchers',
  providers: 'providers',
  dispatches: 'dispatches',
  passports: 'passports',
  dashboards: 'dashboards',
  remittances: 'remittances',
  remittanceFiles: 'remittanceFiles',
  remittanceStatus: 'remittanceStatus',
  remittanceDeliveryTypes: 'remittanceDeliveryTypes',
  migrations: 'migrations',
  migrationFiles: 'migrationFiles',
  migrationStatus: 'migrationStatus',
  migrationFormsSettings: 'migrationFormsSettings',
  remittancePickupLocations: 'remittancePickupLocations',
  transactionSummaries: 'transactionSummaries',
  clientTransactionSummaries: 'clientTransactionSummaries',
  claims: 'claims',
  claimFiles: 'claimFiles',
  receptors: 'receptors',
  distributionClients: 'distributionClients',
  manifests: 'manifests',
  receptions: 'receptions',
  distributorManifests: 'distributorManifests',
  lockerPackages: 'lockerPackages',
  myLockerPackages: 'myLockerPackages',
  myRecipients: 'myRecipients',
  agencyBranding: 'agencyBranding',
  portalMemberships: 'portalMemberships',
  portalLockerAddress: 'portalLockerAddress',
  adminAgencies: 'adminAgencies',
  adminAgencyDefaults: 'adminAgencyDefaults',
  adminAgencyInsights: 'adminAgencyInsights',
  adminAgencyOverview: 'adminAgencyOverview',
  adminAuditLog: 'adminAuditLog',
  platformAdmins: 'platformAdmins',
  platformHealth: 'platformHealth',
  adminRateCard: 'adminRateCard',
  adminBillingProfiles: 'adminBillingProfiles',
  adminBillingProfile: 'adminBillingProfile',
  ownerBillingAccrual: 'ownerBillingAccrual',
  ownerBillingInvoices: 'ownerBillingInvoices',
  ownerCashClose: 'ownerCashClose',
  adminAgencyInvoices: 'adminAgencyInvoices',
  adminBillingOverdue: 'adminBillingOverdue',
  portalShipments: 'portalShipments',
  portalShipment: 'portalShipment',
  portalPassports: 'portalPassports',
  portalPassport: 'portalPassport',
  portalRemittances: 'portalRemittances',
  portalRemittance: 'portalRemittance',
  portalMigrations: 'portalMigrations',
  portalMigration: 'portalMigration',
  portalWhatsAppConsent: 'portalWhatsAppConsent',
  courierCaptureContext: 'courierCaptureContext',
};
